import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  container: {
    position: 'absolute',
    right: 10,
    top: 10,
    zIndex: 10,
  },
  printIconContainer: {
    position: 'relative',
  },
  checkIcon: {
    position: 'absolute',
    right: -11,
    top: 10,
    fontSize: 20,
    color: theme.colors.success,
  },
}));
